import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from '../ui/SectionHeading';
import { Gift } from 'lucide-react';
const bonuses = [{
  id: 'B1',
  title: 'Mazo Completo de Cartas de Conversación',
  desc: 'Las 36 preguntas semanales de los 3 tomos, en un mazo imprimible para usar fuera del libro.',
  image: 'https://images.unsplash.com/photo-1541278107931-e006523892df?auto=format&fit=crop&w=200&q=60'
}, {
  id: 'B2',
  title: 'Guiones de Conversaciones Difíciles',
  desc: 'Qué decir (y qué no) en los temas que más tensión generan: finanzas, nombres, roles, entorno familiar.',
  image: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&w=200&q=60'
}, {
  id: 'B3',
  title: 'Tracker de Nosotros Completo',
  desc: 'La planilla de seguimiento semanal de los 9 meses, en un solo lugar, para ver la evolución del equipo de punta a punta.',
  image: 'https://images.unsplash.com/photo-1517842645767-c639042777db?auto=format&fit=crop&w=200&q=60'
}];
export function Bonuses() {
  return <section className="py-12 md:py-24 px-4 md:px-8 bg-cream" data-id="element-19">
      <div className="max-w-5xl mx-auto" data-id="element-20">
        <SectionHeading title="INCLUIDOS GRATIS" subtitle="3 Bonos Estratégicos. Sin costo extra — incluidos en ambas ofertas" data-id="element-21" />

        <div className="grid md:grid-cols-3 gap-4 md:gap-6 mb-8 md:mb-12" data-id="element-22">
          {bonuses.map((bono, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} whileHover={{
          y: -4
        }} whileTap={{
          scale: 0.98
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-offwhite rounded-2xl border border-brown/10 relative overflow-hidden cursor-pointer hover:border-sage/30 hover:shadow-sm transition-all flex md:flex-col" data-id="element-23">
              <div className="relative w-24 md:w-full md:h-28 shrink-0 overflow-hidden" data-id="element-24">
                <img src={bono.image} alt={bono.title} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-25" />
                <div className="absolute top-0 left-0 bg-sage text-offwhite font-serif font-bold text-[10px] md:text-xs px-2 py-0.5 rounded-br-lg" data-id="element-26">
                  {bono.id}
                </div>
              </div>

              <div className="p-3 md:p-5 flex-1 min-w-0" data-id="element-27">
                <div className="flex items-center gap-2 mb-1.5" data-id="element-28">
                  <h3 className="font-serif font-bold text-sm md:text-base text-brown leading-tight" data-id="element-29">
                    {bono.title}
                  </h3>
                  <span className="bg-sage/15 text-sage font-sans font-bold text-[10px] px-2 py-0.5 rounded-full shrink-0" data-id="element-30">
                    GRATIS
                  </span>
                </div>
                <p className="font-sans text-xs md:text-sm text-brown/70 leading-relaxed" data-id="element-31">
                  {bono.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center bg-sage/10 p-4 md:p-6 rounded-2xl max-w-md mx-auto border border-sage/20" data-id="element-32">
          <div className="flex items-center justify-center gap-2 text-sage font-serif font-bold text-lg md:text-xl" data-id="element-33">
            <Gift size={20} className="md:w-6 md:h-6" data-id="element-34" />
            VALOR TOTAL: $45.000 — GRATIS
          </div>
        </motion.div>
      </div>
    </section>;
}